import InvisibilityIcon from './InvisibilityIcon'

export default InvisibilityIcon
